module.exports = __webpack_public_path__ + "img/np.1452f3dc.svg";